<ng-container *ngTemplateOutlet="listTemplate || defaultListTemplate; 
    context: {$implicit: items, selectItem: selectItem, defaultEmptyListTemplate: defaultEmptyListTemplate}">
</ng-container>

<ng-template #defaultListTemplate 
             let-items 
             let-selectItem="selectItem" 
             let-defaultEmptyListTemplate="defaultEmptyListTemplate">

    @if (items?.length > 0) {
        <div class="list-group mb-4 itemlist">
            @for (item of items; track item) {
                <a href="javascript:void(0)" 
                   class="list-group-item list-group-item-action" 
                   (click)="selectItem(item)"
                   [class.active]="item === selectedItem">
                    <ng-container *ngTemplateOutlet="listItemTemplate; context: {$implicit: item}"></ng-container>
                </a>
            }
        </div>
    } @else {
        <ng-container *ngTemplateOutlet="defaultEmptyListTemplate"></ng-container>
    }
</ng-template>

<ng-template #defaultEmptyListTemplate>
    <div class="card card-body bg-light">
        {{ 'UI.Message.NoDataToDisplay|A szűrési feltételeknek nincs megjeleníthető eredménye!' | translate }}
    </div>
</ng-template>